import { useNavigate } from 'react-router-dom'

import { useHasPermissions } from '@/lib/app/check-permissions.hook'
import { AppRoute } from '@/lib/url/urls'

import { Empty } from '@/components/lemmala-design-system/empty/empty'

export const UnauthorizedAccess = () => {
  const hasViewPermissions = useHasPermissions(['base.view'])
  const referToRequests = !hasViewPermissions
  const navigate = useNavigate()
  return (
    <Empty
      icon='primary'
      title="You don't have permission to view this page."
      subtitle={
        referToRequests
          ? 'You may be looking for a different section — try the third-party requests page instead.'
          : undefined
      }
      button={
        referToRequests
          ? {
              label: 'Redirect to third-party requests',
              variant: 'outline',
              onClick: () => navigate(AppRoute.COMPANY_REQUEST),
            }
          : {
              label: 'Go to home',
              variant: 'outline',
              onClick: () => navigate(AppRoute.OVERVIEW),
            }
      }
      className='h-full'
    />
  )
}
